import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import loginlogo from '../assets/images/loginlogo.jpg';
import '../assets/styles/Login.css';
import { validateBranchUser, validateCompanyUser } from "./Validation";
import { CompanyContext } from "../context/CompanyContext";

const BranchLogin = () => {

  const { companyInfo } = useContext(CompanyContext)
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const navigate = useNavigate();

  const initialFormData = {
    userMaster: {
      userCode: "",
      userPassword: "Kannan@2003"
    },
    branchInfo: {
      brNameEng: ""
    }
  };
  console.log(companyInfo);

  const [userData, setUserData] = useState(initialFormData);
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "brNameEng") {
      setUserData((prevData) => ({
        ...prevData,
        branchInfo: {
          ...prevData.branchInfo,
          brNameEng: value
        }
      }));
    } else {
      setUserData((prevData) => ({
        ...prevData,
        userMaster: {
          ...prevData.userMaster,
          [name]: value
        }
      }));
    }

    const updatedData = {
      ...userData,
      userMaster: {
        ...userData.userMaster,
        [name]: name !== "brNameEng" ? value : userData.userMaster[name],
      },
      branchInfo: {
        ...userData.branchInfo,
        brNameEng: name === "brNameEng" ? value : userData.branchInfo.brNameEng,
      }
    };

    const validationErrors = validateBranchUser(updatedData);
    setErrors(validationErrors);
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    const validationErrors = validateBranchUser(userData); // Update if needed
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
      const res = await axios.post("http://192.168.1.18:8082/userBranch/login", userData);
      if (res.data === "Login successful") {
        setAlert({ show: true, type: "success", message: "Login Successfully" });
        const redirectTo = localStorage.getItem("redirectAfterLogin") || "/branch-dashboard";
        localStorage.removeItem("redirectAfterLogin");
        navigate(redirectTo);
      } else {
        setAlert({ show: true, type: "error", message: "Invalid username or password!" });
      }
    } catch (error) {
      setAlert({ show: true, type: "error", message: "Login failed. Please try again." });
    }
  };

  return (
    <div className="container">
      <div className="login-container">
        <div className="login-box">
          <div className="login-left">
            <img src={loginlogo} alt="Login" />
          </div>
          <div className="login-right">
            <h2>Branch Login</h2>
            {alert.show && (
              <div className={`alert ${alert.type}`}>{alert.message}</div>
            )}
            <form onSubmit={handleLogin}>
              <input
                type="text"
                name="userCode"
                placeholder="User Code"
                autoCompl
                value={userData.userMaster.userCode}
                onChange={handleChange}
              />
              {errors.userCode && <small className="error">{errors.userCode}</small>}

              <input
                type="password"
                name="userPassword"
                placeholder="Password"
                value={userData.userMaster.userPassword}
                onChange={handleChange}
              />
              {errors.userPassword && <small className="error">{errors.userPassword}</small>}
              <input
                type="brNameEng"
                name="brNameEng"
                placeholder="brNameEng"
                value={userData.branchInfo.brNameEng}
                onChange={handleChange}
              />
              {errors.brNameEng && <small className="error">{errors.brNameEng}</small>}


              <button type="submit">Sign In</button>
            </form>

            <p>
              Don’t have an account? <Link to="/signup">Register</Link>
            </p>
            <p>
              <Link to="/signin/companyforgot">Forgot Password?</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchLogin;


